angular.module('picmonicng').value('taxableZips', {
  AZ: [
    '85003',
    '85004',
    '85006',
    '85007',
    '85008',
    '85009',
    '85012',
    '85013',
    '85014',
    '85015',
    '85016',
    '85017',
    '85018',
    '85019',
    '85020',
    '85021',
    '85022',
    '85023',
    '85024',
    '85027',
    '85028',
    '85029',
    '85031',
    '85032',
    '85033',
    '85034',
    '85035',
    '85037',
    '85040',
    '85041',
    '85042',
    '85043',
    '85044',
    '85045',
    '85048',
    '85050',
    '85051',
    '85053',
    '85054',
    '85083',
    '85085',
    '85086',
    '85087',
    '85118',
    '85119',
    '85120',
    '85121',
    '85122',
    '85123',
    '85128',
    '85131',
    '85132',
    '85135',
    '85137',
    '85138',
    '85139',
    '85140',
    '85141',
    '85142',
    '85143',
    '85145',
    '85147',
    '85172',
    '85173',
    '85192',
    '85193',
    '85194',
    '85201',
    '85202',
    '85203',
    '85204',
    '85205',
    '85206',
    '85207',
    '85208',
    '85209',
    '85210',
    '85212',
    '85213',
    '85215',
    '85224',
    '85225',
    '85226',
    '85233',
    '85234',
    '85248',
    '85249',
    '85250',
    '85251',
    '85253',
    '85254',
    '85255',
    '85256',
    '85257',
    '85258',
    '85259',
    '85260',
    '85262',
    '85263',
    '85264',
    '85266',
    '85268',
    '85281',
    '85282',
    '85283',
    '85284',
    '85286',
    '85295',
    '85296',
    '85297',
    '85298',
    '85301',
    '85302',
    '85303',
    '85304',
    '85305',
    '85306',
    '85307',
    '85308',
    '85309',
    '85310',
    '85320',
    '85321',
    '85322',
    '85323',
    '85324',
    '85325',
    '85326',
    '85328',
    '85331',
    '85332',
    '85333',
    '85334',
    '85335',
    '85336',
    '85337',
    '85338',
    '85339',
    '85340',
    '85341',
    '85342',
    '85343',
    '85344',
    '85345',
    '85346',
    '85347',
    '85348',
    '85349',
    '85350',
    '85351',
    '85352',
    '85353',
    '85354',
    '85355',
    '85356',
    '85357',
    '85360',
    '85361',
    '85362',
    '85363',
    '85364',
    '85365',
    '85367',
    '85371',
    '85373',
    '85374',
    '85375',
    '85377',
    '85379',
    '85381',
    '85382',
    '85383',
    '85387',
    '85388',
    '85390',
    '85392',
    '85395',
    '85396',
    '85501',
    '85530',
    '85531',
    '85533',
    '85534',
    '85535',
    '85536',
    '85539',
    '85540',
    '85541',
    '85542',
    '85543',
    '85544',
    '85545',
    '85546',
    '85550',
    '85551',
    '85552',
    '85553',
    '85554',
    '85601',
    '85602',
    '85603',
    '85605',
    '85606',
    '85607',
    '85608',
    '85609',
    '85610',
    '85611',
    '85613',
    '85614',
    '85615',
    '85616',
    '85617',
    '85618',
    '85619',
    '85620',
    '85621',
    '85622',
    '85623',
    '85624',
    '85625',
    '85626',
    '85627',
    '85629',
    '85630',
    '85631',
    '85632',
    '85633',
    '85634',
    '85635',
    '85637',
    '85638',
    '85640',
    '85641',
    '85643',
    '85645',
    '85646',
    '85648',
    '85650',
    '85653',
    '85654',
    '85658',
    '85701',
    '85704',
    '85705',
    '85706',
    '85707',
    '85708',
    '85710',
    '85711',
    '85712',
    '85713',
    '85714',
    '85715',
    '85716',
    '85718',
    '85719',
    '85723',
    '85724',
    '85726',
    '85730',
    '85735',
    '85736',
    '85737',
    '85739',
    '85741',
    '85742',
    '85743',
    '85745',
    '85746',
    '85747',
    '85748',
    '85749',
    '85750',
    '85755',
    '85756',
    '85757',
    '85901',
    '85911',
    '85912',
    '85920',
    '85922',
    '85923',
    '85924',
    '85925',
    '85926',
    '85927',
    '85928',
    '85929',
    '85930',
    '85931',
    '85932',
    '85933',
    '85934',
    '85935',
    '85936',
    '85937',
    '85938',
    '85939',
    '85940',
    '85941',
    '85942',
    '86001',
    '86003',
    '86004',
    '86011',
    '86015',
    '86016',
    '86017',
    '86018',
    '86020',
    '86021',
    '86022',
    '86023',
    '86024',
    '86025',
    '86028',
    '86029',
    '86030',
    '86031',
    '86032',
    '86033',
    '86034',
    '86035',
    '86036',
    '86038',
    '86039',
    '86040',
    '86042',
    '86043',
    '86044',
    '86045',
    '86046',
    '86047',
    '86052',
    '86053',
    '86054',
    '86301',
    '86303',
    '86305',
    '86313',
    '86314',
    '86315',
    '86320',
    '86321',
    '86322',
    '86323',
    '86324',
    '86325',
    '86326',
    '86327',
    '86329',
    '86331',
    '86332',
    '86333',
    '86334',
    '86335',
    '86336',
    '86337',
    '86338',
    '86343',
    '86351',
    '86401',
    '86403',
    '86404',
    '86406',
    '86409',
    '86411',
    '86413',
    '86426',
    '86429',
    '86431',
    '86432',
    '86433',
    '86434',
    '86435',
    '86436',
    '86437',
    '86438',
    '86440',
    '86441',
    '86442',
    '86443',
    '86444',
    '86445',
    '86502',
    '86503',
    '86504',
    '86505',
    '86506',
    '86507',
    '86508',
    '86510',
    '86511',
    '86512',
    '86514',
    '86515',
    '86520',
    '86535',
    '86538',
    '86540',
    '86544',
    '86545',
    '86547',
    '86556',
  ],
  UT: [
    '84001',
    '84002',
    '84003',
    '84004',
    '84005',
    '84006',
    '84007',
    '84010',
    '84013',
    '84014',
    '84015',
    '84017',
    '84018',
    '84020',
    '84021',
    '84022',
    '84023',
    '84024',
    '84025',
    '84026',
    '84027',
    '84028',
    '84029',
    '84031',
    '84032',
    '84033',
    '84034',
    '84035',
    '84036',
    '84037',
    '84038',
    '84039',
    '84040',
    '84041',
    '84042',
    '84043',
    '84044',
    '84045',
    '84046',
    '84047',
    '84049',
    '84050',
    '84051',
    '84052',
    '84053',
    '84054',
    '84055',
    '84056',
    '84057',
    '84058',
    '84060',
    '84061',
    '84062',
    '84063',
    '84064',
    '84065',
    '84066',
    '84067',
    '84069',
    '84070',
    '84071',
    '84072',
    '84073',
    '84074',
    '84075',
    '84076',
    '84078',
    '84080',
    '84081',
    '84082',
    '84083',
    '84084',
    '84085',
    '84086',
    '84087',
    '84088',
    '84092',
    '84093',
    '84094',
    '84095',
    '84096',
    '84097',
    '84098',
    '84101',
    '84102',
    '84103',
    '84104',
    '84105',
    '84106',
    '84107',
    '84108',
    '84109',
    '84111',
    '84112',
    '84113',
    '84115',
    '84116',
    '84117',
    '84118',
    '84119',
    '84120',
    '84121',
    '84123',
    '84124',
    '84128',
    '84180',
    '84301',
    '84302',
    '84304',
    '84305',
    '84306',
    '84307',
    '84308',
    '84309',
    '84310',
    '84311',
    '84312',
    '84313',
    '84314',
    '84315',
    '84316',
    '84317',
    '84318',
    '84319',
    '84320',
    '84321',
    '84324',
    '84325',
    '84326',
    '84327',
    '84328',
    '84329',
    '84330',
    '84331',
    '84332',
    '84333',
    '84334',
    '84335',
    '84336',
    '84337',
    '84338',
    '84339',
    '84340',
    '84341',
    '84401',
    '84403',
    '84404',
    '84405',
    '84414',
    '84501',
    '84511',
    '84512',
    '84513',
    '84515',
    '84516',
    '84518',
    '84520',
    '84521',
    '84522',
    '84523',
    '84525',
    '84526',
    '84528',
    '84529',
    '84530',
    '84531',
    '84532',
    '84533',
    '84534',
    '84535',
    '84536',
    '84537',
    '84539',
    '84540',
    '84542',
    '84601',
    '84604',
    '84606',
    '84620',
    '84621',
    '84622',
    '84623',
    '84624',
    '84626',
    '84627',
    '84628',
    '84629',
    '84630',
    '84631',
    '84632',
    '84633',
    '84634',
    '84635',
    '84636',
    '84637',
    '84638',
    '84639',
    '84640',
    '84642',
    '84643',
    '84645',
    '84646',
    '84647',
    '84648',
    '84649',
    '84651',
    '84652',
    '84653',
    '84654',
    '84655',
    '84656',
    '84657',
    '84660',
    '84662',
    '84663',
    '84664',
    '84665',
    '84667',
    '84701',
    '84710',
    '84711',
    '84712',
    '84713',
    '84714',
    '84715',
    '84716',
    '84718',
    '84719',
    '84720',
    '84721',
    '84722',
    '84723',
    '84724',
    '84725',
    '84726',
    '84728',
    '84729',
    '84730',
    '84731',
    '84732',
    '84733',
    '84734',
    '84735',
    '84736',
    '84737',
    '84738',
    '84739',
    '84740',
    '84741',
    '84742',
    '84743',
    '84744',
    '84745',
    '84746',
    '84747',
    '84749',
    '84750',
    '84751',
    '84752',
    '84753',
    '84754',
    '84755',
    '84756',
    '84757',
    '84758',
    '84759',
    '84760',
    '84761',
    '84762',
    '84763',
    '84764',
    '84765',
    '84766',
    '84767',
    '84770',
    '84772',
    '84773',
    '84774',
    '84775',
    '84776',
    '84779',
    '84780',
    '84781',
    '84782',
    '84783',
    '84784',
    '84790',
  ],
});
